module.exports = __webpack_public_path__ + "static/media/Line_Chat_Icon.2b82053e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/footer/Line_Chat_Icon.png
// module id = 1560
// module chunks = 0